import React, { Component } from "react";
import { Card, Button, message, Form, Input, Radio } from "antd";
import { postInvoiceInfo } from "../../api/invoice";
import {convertInvoice} from "@/utils/format"
import Storage from "@/utils/storage";
import AreaDropdown from "../AreaDropdown";
import "./style.less";

const clsPrefix = "c-enterprise";
const clsPrefixbox = "c-enterprise-box";
const RadioGroup = Radio.Group;

const E_INVOICE = "E_INVOICE";
const P_INVOICE = "P_INVOICE";
const COMMON = "COMMON";
const PROFESSIONAL = "PROFESSIONAL";
const ENTERPRISE_ELECTRONIC_INVOICE = "ENTERPRISE_ELECTRONIC_INVOICE";
const ENTERPRISE_PAPER_INVOICE = "ENTERPRISE_PAPER_INVOICE";
const ENTERPRISE_SPECIAL_PRPER_INVOICE = "ENTERPRISE_SPECIAL_PRPER_INVOICE";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};
class EnterpriseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type:ENTERPRISE_ELECTRONIC_INVOICE,
      invoiceType: COMMON,
      invoiceWay: E_INVOICE,
      addressProvince: "北京",
      addressCity: "北京"
    };
  }

  handleChange = (type, e) => {
    this.setState({ [type]: e.target.value });
  };
  setProvinceCity = (province, city) => {
    if (province) {
      this.setState({
        addressProvince: province,
        addressCity: city
      });
    } else {
      this.setState({
        addressCity: city
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, value) => {
      const { invoiceType } = this.state 
      const invoiceWay = ENTERPRISE_ELECTRONIC_INVOICE === invoiceType ? 'E_INVOICE' : 'P_INVOICE'

      if (!err) {
        let initData = {
          ...this.state,
          ...value,
          orderList: Storage.invoiceList.get().map(invoice => invoice.orderId),
          content: "无",
          postCode: "无",
          invoiceWay
        };
        let convertData = convertInvoice(initData.type)
        let data= Object.assign(initData,convertData)
        delete(data.type)
        postInvoiceInfo(data).then(res => {
          if (res.code === 0) {
            message.info("发票申请已提交，请在发票列表查看");
            window.setTimeout(() => {
              window.location.href = "/v5/invoice/invoiceList";
            }, 1000);
          } else {
            message.error(res.msg);
          }
        });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { type } = this.state;

    return (
      <div className={clsPrefix}>
        <Form
          {...formItemLayout}
          onSubmit={this.handleSubmit}
          className={clsPrefixbox}
        >
          <div className='invoice-type item'>
            <div className='leftName'>
              <i className='star1'>*</i>
              <span>发票类型:</span>
            </div>
            <RadioGroup
              className='radioGroup'
              value={type}
              onChange={e => this.handleChange("type", e)}
            >
              <Radio value={ENTERPRISE_ELECTRONIC_INVOICE}>
                增值税普通发票（电子）
              </Radio>
              <Radio value={ENTERPRISE_PAPER_INVOICE}>
                增值税普通发票（纸质）
              </Radio>
              <Radio value={ENTERPRISE_SPECIAL_PRPER_INVOICE}>
                增值税专用发票（纸质）
              </Radio>
            </RadioGroup>
            <Card className='promptCard' type='inner' title='提示' size='small'>
              <div className='enterpriseBox'>
                <p className='ordinary-invoice'>
                  增值税普通发票开具小规模纳税人或者开票资料不齐全时购买人，购买人取得后不可以进行进项税额抵扣，若您还有疑问，建议联系贵公司财务确认后在提交开票需求。
                </p>
                <p className='invoice'>
                  增值税专用发票开具一般纳税人，申请时需要提供公司名称、税号、地址电话、开户行名称以及账号，购买人取得后可以进行想税额抵扣，若您还有疑问，请联系贵公司财务确认后在提交开票需求。
                </p>
              </div>
            </Card>
          </div>
          <Form.Item label={<span>发票抬头&nbsp;</span>}>
            {getFieldDecorator("invoiceTitle", {
              rules: [
                {
                  required: true,
                  message: "请输入你的发票抬头!",
                  whitespace: true
                }
              ]
            })(<Input />)}
          </Form.Item>
          <Form.Item label={<span>税号&nbsp;</span>}>
            {getFieldDecorator("tax", {
              rules: [
                {
                  required: true,
                  message: "请输入你的税号!",
                  whitespace: true
                }
              ]
            })(<Input />)}
          </Form.Item>
          <p className='prompt'>
            请与贵公司人员联系后，仔细填写准确的三证合一的社会统一信用代或税务登记证号，否则将影响后续发票的正常使用
          </p>
          {type === ENTERPRISE_SPECIAL_PRPER_INVOICE ? null : (
            <div className='item'>
              <span className='otherInfoText'>其他发票信息（可选填）</span>
            </div>
          )}
          <div className='special'>
            <Form.Item label={<span>注册场所地址&nbsp;</span>}>
              {getFieldDecorator("enterpriseAddress", {
                rules: [
                  {
                    required: type === ENTERPRISE_SPECIAL_PRPER_INVOICE,
                    message: "请输入你的注册场所地址!",
                    whitespace: true
                  }
                ]
              })(<Input />)}
            </Form.Item>
            <Form.Item label={<span>注册公司电话&nbsp;</span>}>
              {getFieldDecorator("enterpriseTel", {
                rules: [
                  {
                    required: type === ENTERPRISE_SPECIAL_PRPER_INVOICE,
                    message: "请输入你的注册公司电话!",
                    whitespace: true
                  }
                ]
              })(<Input />)}
            </Form.Item>

            <Form.Item label={<span>基本开户银行名称&nbsp;</span>}>
              {getFieldDecorator("accountBank", {
                rules: [
                  {
                    required: type === ENTERPRISE_SPECIAL_PRPER_INVOICE,
                    message: "请输入你的基本开户银行名称!",
                    whitespace: true
                  }
                ]
              })(<Input />)}
            </Form.Item>
            <Form.Item label={<span>基本开户账号&nbsp;</span>}>
              {getFieldDecorator("bankCard", {
                rules: [
                  {
                    required: type === ENTERPRISE_SPECIAL_PRPER_INVOICE,
                    message: "请输入你的基本开户账号!",
                    whitespace: true
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </div>

          <div className='item'>
            <p className='moneyNote'>
              开票金额（普票500元，专票2000元）以下发票邮寄需到付
            </p>
          </div>
          <Form.Item label={<span>收件人&nbsp;</span>}>
            {getFieldDecorator("receiver", {
              rules: [
                {
                  required: true,
                  message: "请输入你的收件人!",
                  whitespace: true
                }
              ]
            })(<Input />)}
          </Form.Item>
          <Form.Item label={<span>手机号&nbsp;</span>}>
            {getFieldDecorator("phoneNumber", {
              rules: [
                {
                  required: true,
                  message: "请输入你的手机号!",
                  whitespace: true
                }
              ]
            })(<Input />)}
          </Form.Item>

          {type === ENTERPRISE_ELECTRONIC_INVOICE ? null : (
            <div>
              <div className='item'>
                <div className='leftName'>
                  <i className='star1'>*</i>
                  <span className='name'>省市地址:</span>
                </div>
                <div className='antInput'>
                  <AreaDropdown setProvinceCity={this.setProvinceCity} />
                </div>
              </div>
              <Form.Item label={<span>详细地址&nbsp;</span>}>
                {getFieldDecorator("addressDetail", {
                  rules: [
                    {
                      required: true,
                      message: "请输入你的详细地址!",
                      whitespace: true
                    }
                  ]
                })(<Input />)}
              </Form.Item>
            </div>
          )}

          {type === ENTERPRISE_ELECTRONIC_INVOICE ? (
            <Form.Item label={<span>收件人邮箱&nbsp;</span>}>
              {getFieldDecorator("email", {
                placeholder: "建议QQ邮箱",
                rules: [
                  {
                    required: type === ENTERPRISE_ELECTRONIC_INVOICE,
                    message: "请输入你的email!",
                    whitespace: true
                  },
                  {
                    type: "email",
                    message: "这是一个无效的E-mail!"
                  }
                ]
              })(<Input />)}
            </Form.Item>
          ) : null}

          <Form.Item {...tailFormItemLayout}>
            <Button type='primary' htmlType='submit'>
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const Enterprise = Form.create({ name: "enterprise" })(EnterpriseForm);
export default Enterprise;
